import { Alert, styled } from '@mui/material';

export const NoProjectsAlertRoot = styled(Alert)({
  '& .MuiAlert-message': {
    width: '100%',
  },
});
